import { clsx } from "clsx"
import Image from "next/image"

interface Props {
    thumbnail?: {
        url?: string | null
        blurDataUrl?: string | null
    }
    title: string
    className?: string
    priority?: boolean
    requireSignedMuxUrl?: boolean
}

export function ThumbnailImage({ className, priority, thumbnail, title, requireSignedMuxUrl = false }: Props) {
    if (!thumbnail?.url) {
        return <div className={clsx("size-full bg-gray-200", className)} />
    }

    const src = getImageSrc(thumbnail.url, requireSignedMuxUrl)

    return (
        <Image
            src={src}
            alt={title}
            className={className}
            priority={priority}
            sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, (max-width: 1536px) 33vw, 25vw"
            fill
            placeholder={thumbnail.blurDataUrl ? "blur" : undefined}
            blurDataURL={thumbnail.blurDataUrl ?? undefined}
        />
    )
}

function getImageSrc(url: string, requireSignedMuxUrl: boolean): string {
    if (!requireSignedMuxUrl) {
        return url
    }

    try {
        const parsed = new URL(url)
        if (parsed.hostname !== "image.mux.com") {
            return url
        }

        const segments = parsed.pathname.split("/").filter(Boolean)
        if (segments.length < 2) {
            return url
        }

        const [playbackId, ...rest] = segments

        if (!playbackId) {
            return url
        }

        const params = new URLSearchParams(parsed.search)

        const search = params.toString()

        const encodedAsset = rest.map((segment) => encodeURIComponent(segment)).join("/")

        return `/api/mux-thumbnail/${encodeURIComponent(playbackId)}${encodedAsset ? `/${encodedAsset}` : ""}${
            search ? `?${search}` : ""
        }`
    } catch {
        return url
    }
}
